import React from 'react';
import { RecommendedProducts } from '@ifixit/product-page-components';
import { addSkus } from './Shared/add_to_cart.js';
import { trackEvent } from './Shared/utils.js';
import styled from 'styled-components';

const addToCart = products => {
   const skus = products.map(product => product.sku);
   addSkus(skus);
   const skuList = (App.sku + '/' + skus.join(',')).replace(/(\d{6})/g, '$1-');
   trackEvent('Cross Sell', 'Add to Cart', skuList);
};

const RecommendedProductsContainer = styled.div`
   a:visited {
      color: inherit;
   }
`;

const RecommendedProductsWrapper = props => {
   const { activeProps } = props;
   return (
      <RecommendedProductsContainer>
         <RecommendedProducts
            addToCart={addToCart}
            relatedProducts={activeProps.relatedProducts}
            initialProduct={activeProps.initialProduct}
         />
      </RecommendedProductsContainer>
   );
};

export default RecommendedProductsWrapper;
